export const enum JUSPAY_ENV {
    PROD = "prod",
    SAND_BOX = "sandbox",
}

export interface JuspayTokenizationMeta {
    title: string;
    message: string;
    tncUrl?: string;
    points: Array<{
        iconUrl: string;
        message: string;
    }>;
}

export interface JuspayTokenMetaInterface {
    cardReference: string;
    lastFourDigits: string;
    cardFingerprint: string;
    cardIsin: string;
    expiryYear: string;
    expiryMonth: string;
    tokenizationStatus: string;
    par: string;
}

